import { useMutation, useQueryClient } from '@tanstack/react-query';
import { loaders } from './admins.loaders';
import { adminsKeys } from './admins.queries';

export const useCreateAdmin = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.createAdmin, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminsKeys.all);
    },
  });
};

export const useCreateProgrammaticAdmin = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.createProgrammaticAdmin, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminsKeys.all);
    },
  });
};

export const useUpdateAdmin = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateAdmin, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminsKeys.all);
    },
  });
};

export const useUpdateMe = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateMe, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminsKeys.all);
    },
  });
};

export const useDeleteAdmin = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.deleteAdmin, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminsKeys.lists);
    },
  });
};

export const useSendInvite = () => {
  return useMutation(loaders.sendInvite);
};

export const useCreateAdminToken = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.createAdminToken, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminsKeys.all);
    },
  });
};

export const useDeleteAdminToken = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.deleteAdminToken, {
    onSuccess: () => {
      return queryClient.invalidateQueries(adminsKeys.all);
    },
  });
};
